{
  "subtitle_count": "{n} project | {n} projects",
  "new_project": "New project",
  "empty_title": "You don't have any projects yet",
  "empty_subtitle": "Create your first one to organize your tasks.",
  "create_project": "Create project",
  "no_description": "No description.",
  "workspace_tag": "Whole workspace",
  "group_none": "No team",
  "private_project": "Private project",
  "favorite_add": "Add to favorites",
  "favorite_remove": "Remove from favorites",
  "favorite_error": "Couldn't update the favorite.",
  "members_count_title": "{n} explicit members",
  "tasks_count": "{n} task | {n} tasks",
  "filters": {
    "search_placeholder": "Search project…",
    "department_label": "Team",
    "department_all": "All teams",
    "health_label": "Status",
    "health_all": "All statuses",
    "favorites_only": "Favorites only",
    "clear": "Clear filters",
    "n_selected": "{n} selected",
    "no_match_title": "No project matches",
    "no_match_body": "Try different filters or clear them."
  },
  "modal": {
    "title": "New project",
    "field_name": "Name",
    "field_description": "Description",
    "field_color": "Color",
    "field_department": "Team",
    "field_optional": "(optional)",
    "department_all": "Visible to the whole workspace",
    "department_only": "Only {name}",
    "department_help": "If you pick a team, only its members (plus owners/admins) will see the project.",
    "private_label": "Private project",
    "private_help": "Only the members you explicitly add will see it, ignoring the selected team.",
    "cancel": "Cancel",
    "submit": "Create project",
    "error_generic": "Error creating project."
  }
}
